// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.u64().primaryKey(),
  matchId: __t.u64().name("match_id"),
  round: __t.u32(),
  p1Move: __t.u32().name("p_1_move"),
  p2Move: __t.u32().name("p_2_move"),
  p1Energy: __t.i32().name("p_1_energy"),
  p2Energy: __t.i32().name("p_2_energy"),
  p1Score: __t.u32().name("p_1_score"),
  p2Score: __t.u32().name("p_2_score"),
  p1Result: __t.string().name("p_1_result"),
  p2Result: __t.string().name("p_2_result"),
  overclockSeed: __t.option(__t.string()).name("overclock_seed"),
  createdAtMicros: __t.u64().name("created_at_micros"),
});
